import { render, staticRenderFns } from "./Directs.vue?vue&type=template&id=63b4f098"
import script from "./Directs.vue?vue&type=script&lang=js"
export * from "./Directs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports